<!-- LOADING -->
<div *ngIf="uploading" class="ud-loading">
  <div class="ud-loading__icon-wrap">
    <mat-icon>cloud_upload</mat-icon>
  </div>
  <div class="ud-loading__dots">
    <span></span><span></span><span></span>
  </div>
  <p class="ud-loading__text">Subiendo archivos…</p>
</div>

<!-- CONTENT -->
<ng-container *ngIf="!uploading">
  <div class="ud-header">
    <div class="ud-header__icon-wrap">
      <mat-icon>cloud_upload</mat-icon>
    </div>
    <div>
      <h2 mat-dialog-title class="ud-header__title">Subir archivos</h2>
      <p class="ud-header__sub">Hasta <strong>10 archivos</strong> · Formatos: imagen, PDF, DOCX, XLSX</p>
    </div>
    <button mat-icon-button class="ud-close" (click)="closeDialog()" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="ud-content">
    <!-- DROP ZONE -->
    <div class="ud-dropzone" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)">
      <mat-icon class="ud-dropzone__icon">attach_file</mat-icon>
      <p class="ud-dropzone__main">Arrastra archivos aquí</p>
      <p class="ud-dropzone__sub">o haz clic para seleccionarlos</p>
      <input hidden type="file" #fileInput multiple (change)="uploadFile($event.target.files)" />
    </div>

    <!-- FILES LIST -->
    <div class="ud-files" *ngIf="files.length > 0">
      <div class="ud-file" *ngFor="let file of files; let i = index; trackBy: trackByIndex">
        <mat-icon class="ud-file__icon">description</mat-icon>
        <span class="ud-file__name">{{ file }}</span>
        <button mat-icon-button class="ud-file__del" (click)="deleteAttachment(i)" matTooltip="Quitar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- MENSAJES -->
    <div class="ud-messages" *ngIf="messages.length > 0">
      <div class="ud-message" *ngFor="let item of messages; trackBy: trackByIndex">
        <mat-icon>info_outline</mat-icon>
        <span>{{ item }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="ud-actions">
    <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
  </mat-dialog-actions>
</ng-container>
